import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { CartActions, StateWithMultiCart } from '@spartacus/cart/base/core';
import { ActiveCartFacade, MultiCartFacade } from '@spartacus/cart/base/root';
import { SavedCartFacade } from '@spartacus/cart/saved-cart/root';
import { filter, take } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import { CartTrackingService } from 'src/app/customServices/cart-tracking.service';
import { SavedShoppingCartService } from 'src/app/services/feature/savedShoppingCart/saved-shopping-cart.service';
@Component({
  selector: 'app-restore-saved-cart-dialog',
  templateUrl: './restore-saved-cart-dialog.component.html',
  styleUrls: ['./restore-saved-cart-dialog.component.scss'],
  standalone: false
})
export class RestoreSavedCartDialogComponent {
  loading = false;
  subscription = new Subscription();
  constructor(@Inject(MAT_DIALOG_DATA) public _data: any, public dialogRef: MatDialogRef<RestoreSavedCartDialogComponent>,
    private savedShoppingCartService: SavedShoppingCartService, private cartTrackingService: CartTrackingService,
    protected savedCartService: SavedCartFacade,
    private multiCartService: MultiCartFacade,
    private activeCartService: ActiveCartFacade,
    protected store: Store<StateWithMultiCart>) {

  }
  restore() {
    this.loading = true;
    this.subscription.add(this.savedShoppingCartService.restoreCart(this._data.id).subscribe({
      next: (data: any) => {
        if (data.savedCartData.code) {
          this.cartTrackingService.trackRestoreCart(this._data.id, data.savedCartData.code, this._data.name, data.currentB2BUnit?.uid);
          this.store.dispatch(new CartActions.SetActiveCartId(data.savedCartData.code));
          this.activeCartService
            .getActiveCartId()
            .pipe(
              filter(id => id === data.savedCartData.code),
              take(1)
            )
            .subscribe(() => {
              // Step 3: DIRECT LOAD (not reload)
              this.multiCartService.loadCart({
                userId: 'current',
                cartId: data.savedCartData.code,
                extraData: { active: true },
              });
            });

          this.dialogRef.close(data.savedCartData.code);
        }
      },
      error: () => {
        this.loading = false;
      }
    }));
  }

  cancel() {
    this.dialogRef.close();
  }
  ngOnDestroy(): void {
    // Unsubscribe from the scroll event
    this.subscription.unsubscribe();
  }

}
